const DeliveryWorkerVerify = () =>
  import(/* webpackChunkName: 'deliveryWorkerVerify' */ '@/pages/delivery-worker-verify/pages/index.vue')
export default [
  {
    path: '/delivery-worker-verify',
    name: 'DeliveryWorkerVerify',
    component: DeliveryWorkerVerify,
  },
]